"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UninvestedRequest = void 0;
var UninvestedRequest = /** @class */ (function () {
    function UninvestedRequest() {
    }
    return UninvestedRequest;
}());
exports.UninvestedRequest = UninvestedRequest;
;
//# sourceMappingURL=uninvested.request.js.map